import React from 'react';
import { useTranslation } from 'react-i18next';
import callIcon from '../assets/icons/call.svg';  // Import call icon
import emailIcon from '../assets/icons/email.svg'; // Import email icon
import { Link } from 'react-router-dom'; // Import Link from react-router-dom


function Footer() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <footer className="footer">
      <div className="links">
        {/* Feedback */}
        <a
  href={t('feedback_url')}
  target="_blank"
  className="card-link"
  id="feedback"
  rel="noopener noreferrer"
  style={{ color: 'inherit', textDecoration: 'none' }}
>
  <p>{t('feedback') || 'test'}</p> {/* You can add 'Default Text' to check if it works */}
</a>


        {/* Terms of Use */}
        <Link className="nav-link" to="/TermsOfUse" id="terms_of_use">
                  {t('terms_of_use')}
                  </Link>
        

        {/* Privacy Policy */}
        <Link className="nav-link" to="/privacy-policy" id="privacyPolicy">
                  {t('privacy_policy')}
                  </Link>
        

        {/* FAQ */}
        <Link className="nav-link" to="/FAQ" id="FAQ">
                  {t('faq')}
                  </Link>
        
      </div>

      {/* Divider */}
      <div className="divider"></div>

      {/* Contact Info */}
      <div className="contact-infos">
        <div className="contact_card">
          <img src={callIcon} alt={t('phone_icon_alt')} className="icon" />
          <div className="contact_info">
            <p className="label">{t('contact_number_label')}</p>
            <p className="number">{t('contact_number')}</p>
          </div>
        </div>

        {/* Footer copyright */}
        <ul className="social-icons">
          <li>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{t('footer_copyright')}</p>
          </li>
        </ul>

        {/* Email */}
        <div className="contact_card">
          <img src={emailIcon} alt={t('email_icon_alt')} className="icon" />
          <div className="contact_info">
            <p className="label">{t('email_address_label')}</p>
            <a
              href={`mailto:${t('email_address')}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <p className="number">{t('email_address')}</p>
            </a>
          </div>
        </div>
      </div>

      {/* Optional Footer Bottom Section */}
      {/* 
      <div className="divider"></div>
      <div className="footer-bottom">
        <div className="copy-right">
          <p>&copy; 2023</p>
          <p>{t('footer_copyright')}</p>
        </div>
        <p>{t('footer_policy')}</p>
      </div>
      */}
    </footer>
  );
}

export default Footer;
